module.exports = __webpack_public_path__ + "img/t_layout.5919b6f4.gif";